import Style from '../../builder/layout/panels/panelStyles.module.scss';
import { useEffect, useState } from 'react';
import { PanelContainer } from '../../builder/layout/panels/uiKit/panelContainer/panelContainer';
import { ControlsGroup } from '../../builder/layout/panels/uiKit/controlsGroup/controlsGroup';
import { SettingsInput } from '../../builder/layout/panels/uiKit/input/settingsInput';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';

export const useMonitoringFormsConfigPanel = ({ initialTitle }: { initialTitle?: string }) => {
  const { t } = useScopedTranslation('GeneralFormBuilder.Panels.FormsConfigSettings');
  const [title, setTitle] = useState<string>(initialTitle ?? '');
  useEffect(() => {
    setTitle(initialTitle ?? '');
  }, [initialTitle]);

  const [titleError, setTitleError] = useState<string | undefined>();

  return {
    title: title,
    panelComponent: (
      <PanelContainer header={t('Header')} expanded={!!titleError} panelName={'FormsConfig'}>
        <ControlsGroup header={t('TitleField.Label')} contentClassName={Style.flexContainer}>
          <SettingsInput
            placeholder={t('TitleField.Placeholder')}
            value={title}
            onChange={(e) => {
              setTitleError(undefined);
              setTitle(e.target.value);
            }}
          />
        </ControlsGroup>
      </PanelContainer>
    ),
  };
};
